export default "__VITE_ASSET__DfuuuwIs__"